import React, { ReactElement } from 'react';

import { Heading } from 'components/Heading';
import Text from 'components/Text';

import { TStatusProps } from './Status.types';
import { STATUS_CONTENT_TYPE } from './Status.constants';
import styles from './Status.module.scss';

function Status({
  type,
  title,
  description,
  descriptionSize = 'large',
}: TStatusProps): ReactElement {
  return (
    <div className={styles.wrapper} data-testid="Status">
      <div className={styles.iconWrapper}>{STATUS_CONTENT_TYPE[type].icon}</div>
      <div className={styles.headingWrapper}>
        <Heading color={STATUS_CONTENT_TYPE[type].headingColor}>
          {title}
        </Heading>
      </div>
      {description && (
        <div className={styles.descriptionWrapper}>
          <Text as="div" size={descriptionSize} data-testid="StatusDescription">
            {description}
          </Text>
        </div>
      )}
    </div>
  );
}

export default Status;
